module.exports = __webpack_public_path__ + "img/03.a26ae015.png";